import React from 'react';
import { ShowInfo } from './ShowInfo/ShowInfo';
import { useShowDetails } from './use-show-details';
import { useShowSections } from './use-show-sections';
import { times } from '../../../../play-core/utils/times';
import { useLoadingBar } from '../../components/LoadingBar/LoadingBarProvider';
import { ErrorFallback } from '../../components/Message/ErrorFallback';
import { usePageTitle } from '../../components/Meta/PlayMetaData';
import { Sections } from '../../components/Section/Sections';
import { Swimlane } from '../../components/Swimlane/Swimlane';
import { SwimlaneTitle } from '../../components/Swimlane/SwimlaneTitle';
import { Swipeable } from '../../components/Swipeable/Swipeable';
import { MediaTeaserPlaceholder } from '../../components/Teaser/MediaTeaser/MediaTeaserPlaceholder';
import { useRouteState } from '../../hooks/use-route-state';
import { useValidTopic } from '../../hooks/use-valid-topic';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ShowPage = ({
  initialData
}) => {
  const {
    squeezedShowDetail
  } = useRouteState();
  const {
    show: loadedShowDetail,
    isLoading: showDetailLoading,
    error
  } = useShowDetails(initialData);
  const showDetail = loadedShowDetail || squeezedShowDetail;
  const validTopic = useValidTopic(showDetail?.topicUrns.map(urn => ({
    urn
  })) ?? []);
  const {
    showSections,
    sectionsLoading
  } = useShowSections(initialData, showDetail?.urn);
  const isLoading = showDetailLoading || sectionsLoading;
  useLoadingBar(isLoading);
  usePageTitle(showDetail?.title);
  return /*#__PURE__*/_jsxs(ErrorFallback, {
    hasError: error,
    children: [/*#__PURE__*/_jsx(ShowInfo, {
      showDetail: showDetail,
      topic: validTopic
    }), !isLoading && /*#__PURE__*/_jsx(Sections, {
      initialData: initialData,
      sections: showSections
    }), isLoading && times(3, index => /*#__PURE__*/_jsxs(Swimlane, {
      children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
        title: '\u0000'
      }), /*#__PURE__*/_jsx(Swipeable, {
        placeholder: index % 2 === 0 ? /*#__PURE__*/_jsx(MediaTeaserPlaceholder, {}) : undefined
      })]
    }, index))]
  });
};